<template>
  <main>
    <section>
      <h4>Introdução</h4>
      <p class="text-justify">
        Um universo de tema medieval, sem mar, apenas alguns rios e lagos e
        coberto por imensas florestas, pântanos e montanhas. O mundo possui um
        dia composto por apenas 4 horas de luz solar e 26 horas de noite
        iluminada por três luas, uma pequena avermelhada, uma média azulada e
        uma enorme lua amarela. A magia é abundante nesse universo, porém são
        poucos os que conseguem manipular ela de forma correta. O mundo é
        habitado por diversos seres como humanos, elfos, anões, orcs.
      </p>
    </section>
    <hr />

    <section>
      <h4>História Principal</h4>
      <p class="text-justify">
        Há aproximadamente 1200 anos atrás, o mundo tinha apenas pequenos
        vilareijos nas florestas onde humanos e elfos conviviam em paz e
        harmonia e nas montanhas orcs e anões trabalhavam em conjunto para
        construir seus clãs. Em um desses vilareijos, um homem com grande sede
        de poder, resolveu mexer com <strong>Magia Anciã</strong>, a forma mais
        poderosa, porém mais perigosa de magia que existe. Ele queria tornar seu
        filho, <strong>Sorin</strong>, em um guerreiro poderoso para conquistar
        outros vilareijos. Seu plano funcionou, <strong>Sorin</strong> ganhou
        poderes que nunca sonhou e que nunca pediu, mas algumas coisas não
        saíram como planejado. <strong>Sorin</strong> foi amaldiçoado a viver
        eternamente, mas com uma sede de sangue que só seria saciada se bebesse
        o sangue de suas vítimas diretamente de seu corpo. Assim,
        <strong>Sorin</strong> se tornou o primeiro e único vampiro.
      </p>

      <p class="text-justify">
        Em poucas semanas, a sede de sangue de <strong>Sorin</strong> fez com
        que ele matasse todos no seu vilareijo, inclusive sua família. Ele ainda
        não sabia controlar seus poderes. Depois disso se isolou do mundo,
        vivendo escondido pelos pântanos e florestas e se alimentando de
        viajantes que tinham o azar de estar na hora e no lugar errado.
        <strong>Sorin</strong>
        viveu dessa maneira por mais de um milênio, até ter a certeza e total
        controle sobre todos seus poderes.
      </p>

      <p class="text-justify">
        Quando voltou a andar pelo mundo, viu que o mundo estava dividido entre
        dois impérios. Passou anos andando como um viajante, tirando suas
        próprias conclusões de como o mundo estava. <strong>Sorin</strong> não
        concordava com nenhum dos impérios e resolveu criar seu próprio império,
        ao qual deu o humilde nome de <strong>Império Eterno</strong>. Seu modo
        de falar era cativante e ele conseguiu muitos seguidores e aliados em
        pouco tempo.
      </p>

      <p class="text-justify">
        Os outros dois impérios: o <strong>Império das Pedras</strong>, quase
        totalmente composto por orcs e anões e o
        <strong>Império da Folha da Vida</strong>, quase totalmente composto por
        elfos, ficaram muito apreensivos com a ascenção de um novo imperador,
        mas despertou muito o interesse da filha do imperador da
        <strong>Folha da Vida</strong>, uma elfa chamada
        <strong>Liz</strong> que saiu de suas terras para se encontrar
        pessoalmente com <strong>Sorin</strong>, porém, sem sua família saber.
        <strong>Liz</strong> é uma guerreira extremamente poderosa e uma das
        principais generais do <strong>Império da Folha da Vida</strong>.
      </p>

      <p class="text-justify">
        <strong>Liz</strong> ao se encontrar com <strong>Sorin</strong> não
        revelou quem ela era, mas o que nenhum deles esperava, era que iriam se
        apaixonar. <strong>Liz</strong> não retornou mais para suas terras e
        passou a ser a general do exército do <strong>Império Eterno</strong>,
        se tornando ainda mais forte sobre a tutoria de
        <strong>Sorin</strong> que a ajudou a desenvolver seu potencial no
        controle da magia para um nível muito avançado, sendo capaz de manipular
        até mesmo a <strong>Magia Anciã</strong>.
      </p>

      <p class="text-justify">
        Com as habilidades adquiridas da <strong>Magia Anciã</strong>,
        <strong>Liz</strong> conseguiu reforçar o exército do
        <strong>Império Eterno</strong> criando criaturas chamadas
        <strong>Giganto</strong>, que são criaturas criadas diretamente de
        pedra, que gahnam vida através da <strong>Magia Anciã</strong>. A
        primeira dessas criaturas é o guarda pessoal de <strong>Liz</strong>,
        chamado de <strong>Giganto #1</strong>, está ao lado de
        <strong>Liz</strong> o tempo todo, exceto quando ela está sozinha com
        <strong>Sorin</strong>.
      </p>

      <p class="text-justify">
        Depois que <strong>Liz</strong> abandonou sua família, seu irmão
        <strong>Serlyon</strong> se tornou o responsável pelos exércitos do
        império. Ele e seu pai ficaram muito revoltados com a atitude de
        <strong>Liz</strong> e concentraram todo o exército contra o
        <strong>Império Eterno</strong>. Depois de diversos ataques em regiões
        dominadas por <strong>Sorin</strong> sem sucesso de as conquistar,
        <strong>Serlyon</strong> pede uma reunião com <strong>Liz</strong> que
        aceita apenas se <strong>Sorin</strong> estiver presente. Durante essa
        reunião, <strong>Serlyon</strong> tenta convencer <strong>Liz</strong> a
        voltar com ele, que ao recusar faz com que ele tente a matar com um
        golpe surpresa. <strong>Sorin</strong> consegue para o ataque com seu
        corpo, mas por ser imortal, nada acontece com ele.
        <strong>Sorin</strong> então resolve prender
        <strong>Serlyon</strong> que agora aguarda resgate em uma masmorra no
        pico da <strong>Montanha Gelada</strong>.
      </p>
    </section>
    <hr />

    <characters-list :universe="universe" />
  </main>
</template>

<script>
import CharactersList from '../CharactersList'

export default {
  name: 'maldicao-eterna',

  props: {
    universe: { type: Object, required: true },
  },

  components: { CharactersList },
}
</script>
